import React from "react";
import Headers from "../../../components/Headers";
import { Table, Modal, Button } from "antd";
import "./index.scss";
import NProgress from "nprogress";
import {
  fetchEvaluationUserList,
  fetchEvaluationDetails,
} from "../../../api/evaluation";
const { Column } = Table;
const BreadCrumbData = [
  { path: "/page/ssry/userInfo", name: "试试如意" },
  { path: "/page/ssry/activityCenter", name: "测评活动中心" },
  { path: "/page/ssry/activityDetails", name: "查看详情" },
];
class ActivityDetails extends React.Component {
  state = {
    listQuery: {
      pageNum: 1,
      pageSize: 10,
      tryEvaluationGoodsId: this.props.match.params.id,
    },
    list: [],
    total: 0,
    bigImgUrl: "",
    bigImgVisible: false,
  };
  showBigImg = (url) => {
    this.setState({
      bigImgVisible: true,
      bigImgUrl: url,
    });
  };
  componentDidMount() {
    NProgress.start();
    this.getList();
    NProgress.done();
  }

  getList = () => {
    fetchEvaluationUserList(this.state.listQuery).then((res) => {
      if (res.success) {
        this.setState({
          list: res.data.list,
          total: res.data.total,
        });
      }
    });
  };
  goPage = (value) => {
    console.log(value);
    window.open(value, "_blank");
  };
  render() {
    const { listQuery, list, total } = this.state;

    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="activityDetails_container">
          <Button onClick={() => this.props.history.goBack()}>返回</Button>
          <div className="content">
            <Table
              rowKey="tryUserEvaluationId"
              dataSource={list}
              // locale={{ emptyText: "暂无商户" }}
              pagination={{
                showTotal: () => `共${total}条`,
                total: total,
                current: listQuery.pageNum,
                pageSize: listQuery.pageSize,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "20", "30", "40", "100"],
                onChange: (page, pageSize) => {
                  this.setState(
                    {
                      listQuery: { ...listQuery, pageNum: page },
                    },
                    () => this.getList()
                  );
                },
                onShowSizeChange: (current, pageSize) => {
                  this.setState(
                    {
                      listQuery: { ...listQuery, pageSize, pageNum: 1 },
                    },
                    () => this.getList()
                  );
                },
              }}
            >
              <Column title="用户昵称" dataIndex="nickName" key="nickName" />
              <Column
                title="手机号码"
                dataIndex="mobilePhone"
                key="mobilePhone"
              />
              <Column
                title="主页链接"
                className="homeLink"
                dataIndex="homeLink"
                key="homeLink"
                width="30%"
                render={(value) =>
                  value ? (
                    <a href={value} target="_blank">
                      {value}
                    </a>
                  ) : (
                    ""
                  )
                }
              />
              <Column
                title="主页截图"
                dataIndex="homeScreenshot"
                key="homeScreenshot"
                render={(text) => (
                  <img
                    onClick={() => this.showBigImg(text)}
                    style={{ width: 40, height: 40, cursor: "pointer" }}
                    src={text}
                  ></img>
                )}
              />
              <Column
                title="测评截图"
                dataIndex="screenshot"
                key="screenshot"
                render={(text) => (
                  <img
                    onClick={() => this.showBigImg(text)}
                    style={{ width: 40, height: 40, cursor: "pointer" }}
                    src={text}
                  ></img>
                )}
              />
              <Column
                title="上传时间"
                dataIndex="createTime"
                key="createTime"
              />
            </Table>
          </div>
        </div>
        <Modal
          title="图片预览"
          onCancel={() => this.setState({ bigImgVisible: false })}
          visible={this.state.bigImgVisible}
          footer={null}
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src={this.state.bigImgUrl}
          ></img>
        </Modal>
      </div>
    );
  }
}

export default ActivityDetails;
